import type { UserRole } from '@wineryxplorer/shared';
import { RoleBadge, UserAvatar } from './UserIdentity';

interface AdminUserDetailHeaderProps {
  name?: string;
  userName: string;
  role: UserRole;
  image?: string;
  avatar?: string;
  isDeactivated: boolean;
  canManageActivation: boolean;
  canChangeRole: boolean;
  onChangeRole: () => void;
  onDeactivate: () => void;
  onReactivate: () => void;
}

export const AdminUserDetailHeader = ({
  name,
  userName,
  role,
  image,
  avatar,
  isDeactivated,
  canManageActivation,
  canChangeRole,
  onChangeRole,
  onDeactivate,
  onReactivate,
}: AdminUserDetailHeaderProps) => (
  <div className="flex items-start gap-4 mb-6">
    <UserAvatar name={name} image={image} avatar={avatar} size="lg" />
    <div className="flex-1 min-w-0">
      <h1 className="text-2xl font-bold text-gray-900 truncate">{name || 'Unnamed User'}</h1>
      <p className="text-gray-500">@{userName}</p>
      <div className="flex items-center gap-2 mt-1">
        <RoleBadge role={role} size="lg" />
        {isDeactivated ? (
          <span className="inline-flex items-center px-3 py-1 rounded text-sm font-medium bg-red-100 text-red-700">
            Deactivated
          </span>
        ) : (
          <span className="inline-flex items-center px-3 py-1 rounded text-sm font-medium bg-green-100 text-green-700">
            Active
          </span>
        )}
      </div>
      {(canManageActivation || canChangeRole) && (
        <div className="mt-2 flex items-center gap-2">
          {canChangeRole && (
            <button
              onClick={onChangeRole}
              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-sm font-medium"
            >
              Change Role
            </button>
          )}
          {canManageActivation && (
            <>
              {isDeactivated ? (
                <button
                  onClick={onReactivate}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
                >
                  Reactivate Account
                </button>
              ) : (
                <button
                  onClick={onDeactivate}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
                >
                  Deactivate Account
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  </div>
);
